import { createRouter, createWebHistory } from 'vue-router'
import BodyView from "@/components/BodyView.vue"
import auth from "@/auth/AuthView.vue"
import login from "@/auth/LoginPage.vue"
import DefaultDashboard from "@/pages/dashboard/DefaultDashboard.vue"
import Draw from "@/pages/draw/DrawIndex.vue"
import DrawResultIndex from "@/pages/drawresult/DrawResultIndex.vue"
import UserIndex from "@/pages/users/UserIndex.vue"
import RoleIndex from "@/pages/roles/RoleIndex.vue"
import ApiClientIndex from "@/pages/apiclient/ApiClientIndex.vue"
import SystemIndex from "@/pages/system/SystemIndex.vue"
import LogIndex from "@/pages/system/LogIndex.vue"
import EditProfile from "@/pages/users/EditProfile.vue"
import store from "@/store"
import { isTokenUsable } from "@/utils/auth"

const routes = [
  {
    path: "",
    redirect: "/dashboard/default"
  },
  {
    path: '/',
    name: 'home',
    component:BodyView,
    meta: {
      title: 'Six4D - Lottery Management System | Dashboard',
      permission: 'dashboard:read',
    },
    children: [
      {
       path: '',
       name: 'defaultRoot',
       component: DefaultDashboard,
      }
     ]
  },
  {
    path:"/auth",
    component: auth,
    children:[
      {
        path:"login",
        name:"login",
        component:login,
        meta: {
          title: 'Six4D - Lottery Management System | Login',
        },
      }
    ]
  },
  {
    path:"/dashboard",
    name:"homes",
    component:BodyView,
    meta: {
      permission: 'dashboard:read',
    },
    children: [
      {
        path: 'default',
        name: 'default',
        component: DefaultDashboard,
        meta: {
          title: 'Dashboard | Six4D - Lottery Management System',
        }
      },
    ]
  },
  {
    path: '/app',
    component: BodyView,
    children: [
    {
      path: 'draw',
      name: 'Draw',
      component: Draw,
       meta: {
          title: 'Draw | Six4D - Lottery Management System',
        }
    },
    {
      path: 'draw-results',
      name: 'DrawResults',
      component: DrawResultIndex,
      meta: {
        title: 'Draw Results | Six4D - Lottery Management System',
      }
    },
    {
      path: 'users',
      name: 'UserManagement',
      component: UserIndex,
      meta: {
        title: 'User Management | Six4D - Lottery Management System',
      }
    },
    {
      path: 'roles',
      name: 'RoleManagement',
      component: RoleIndex,
      meta: {
        title: 'Role Management | Six4D - Lottery Management System',
      }
    },
    {
      path: 'api-clients',
      name: 'ApiClientManagement',
      component: ApiClientIndex,
      meta: {
        title: 'API Client Management | Six4D - Lottery Management System',
      }
    },
    {
      path: 'system-settings',
      name: 'SystemSettings',
      component: SystemIndex,
      meta: {
        title: 'System Settings | Six4D - Lottery Management System',
      }
    },
    {
      path: 'log-center',
      name: 'LogCenter',
      component: LogIndex,
      meta: {
        title: 'Log Center | Six4D - Lottery Management System',
      }
    }
    ]
  },
  {
    path: '/users',
    component: BodyView,
    children: [
      {
        path: 'edit',
        name: 'UserEditProfile',
        component: EditProfile,
        meta: {
          title: 'Edit Profile | Six4D - Lottery Management System',
        },
      },
    ],
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})
router.beforeEach((to, from, next) => {
  if (typeof (to.meta.title) === 'string') {
    document.title = to.meta.title;
  }
  const token = localStorage.getItem('token');
  const hasUsableToken = isTokenUsable(token);

  if (to.path === '/auth/login' && hasUsableToken) {
    const redirect = typeof to.query.redirect === 'string' ? to.query.redirect : '/';
    const isSafeInternalPath = redirect.startsWith('/') && !redirect.startsWith('//');
    return next(isSafeInternalPath ? redirect : '/');
  }

  if (to.path === '/auth/login') {
    return next();
  }

  if (hasUsableToken) {
    const requiredPermissions = to.matched
      .map(record => record.meta && typeof record.meta.permission === 'string' ? record.meta.permission : null)
      .filter(Boolean);

    if (requiredPermissions.length > 0) {
      const grantedPermissions = store.state?.auth?.permissions || [];
      const hasAccess = requiredPermissions.every(permission => grantedPermissions.includes(permission));
      if (!hasAccess) {
        return next('/error-403');
      }
    }

    return next();
  }

  localStorage.removeItem('token');
  store.dispatch('auth/clearPermissions');
  next({
    path: '/auth/login',
    query: {
      redirect: to.fullPath,
    },
  });
});

export default router
